<template>
  <div class="download-fx-wallet flex-center" v-if="showMessageBox">
    <div class="download-fx-wallet-main">
      <div class="download-fx-wallet-top">
        <div class="download-fx-wallet-title">
          <i class="icon icon-close" @click="onShowMessageBox"></i>
        </div>
      </div>
      <div class="download-fx-wallet-content">
        <div class="download-fx-wallet-qr">
          <img :src="downloadQrImg" alt="" />
        </div>
        <h6>{{ $t("common.downloadFxWallet.downloadFxWallet") }}</h6>
        <p>{{ $t("common.downloadFxWallet.downloadFxWalletPlease") }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcode";

export default {
  name: "downloadFxWallet",
  data() {
    return {
      downloadQrImg: "",
    };
  },
  props: {
    showMessageBox: Boolean,
  },
  methods: {
    onShowMessageBox() {
      this.$emit("update:showMessageBox", !this.showMessageBox);
    },
    async getDownloadQR() {
      try {
        const download = process.env.VUE_APP_DOWNLOAD;
        this.downloadQrImg = await QRCode.toDataURL(download, {
          errorCorrectionLevel: "L",
          margin: 0,
        });
      } catch (err) {
        console.error("Generate QR code fail: ", err);
      }
    },
  },
  created() {
    this.getDownloadQR();
  },
};
</script>
<style lang="scss" scoped>
.download-fx-wallet {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: colorRgba(#000, 0.8);
  .download-fx-wallet-main {
    width: 360px;
    background: #2a2c32;
    border: 0.5px solid rgba(255, 255, 255, 0.16);
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.5);
    border-radius: 12px;

    .download-fx-wallet-top {
      padding: 19px;
      background-color: #2a2c32;
      border-radius: 12px;
    }

    .download-fx-wallet-title {
      position: relative;
      padding-bottom: 8px;
      .icon-close {
        width: 20px;
        height: 20px;
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
      }
    }

    .download-fx-wallet-content {
      padding-bottom: 45px;
      h6 {
        text-align: center;
        margin-top: 24px;
        margin-bottom: 12px;
        -webkit-background-clip: text;
        color: transparent;
        background-image: linear-gradient(
          45deg,
          #1d97c7 0%,
          #5178f0 50%,
          #875ff3 100%
        );
      }
      p {
        max-width: 264px;
        margin: 0 auto;
        text-align: center;
        line-height: 20px;
      }
      .download-fx-wallet-qr {
        margin: 0 auto;
        box-sizing: border-box;
        width: 176px;
        height: 176px;
        padding: 8px;
        background: $lighten-color;
        border-radius: 12px;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
